import { render, staticRenderFns } from "./BulkTagsDeleteModal.vue?vue&type=template&id=23b9c2df"
import script from "./BulkTagsDeleteModal.vue?vue&type=script&lang=js"
export * from "./BulkTagsDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports